// extracted by mini-css-extract-plugin
export default {"container":"payment-procedure_container__pGeDS","wrapper-content":"payment-procedure_wrapper-content__yymzq","title":"payment-procedure_title__sOQx-"};